import "bootstrap";

import { Fragment, useContext } from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";

import ScrollToTop from "./components/common/ScrollToTop";
import { SurveyModal } from "./components/common/SurveyModal";
import useLocalStorage from "./customHooks/useLocalStorage";
import { I18nContext } from "./i18n";
import DesignGazette from "./views/DesignGazette";
import MainPage from "./views/MainPage";
import PatentGazette from "./views/PatentGazette";
import TrademarkGazette from "./views/TrademarkGazette";
import UtilitymodelGazette from "./views/UtilitymodelGazette";

const App = () => {
  const [activeLink, setActiveLink] = useLocalStorage("activeLink", "Home");
  const { langCode } = useContext(I18nContext);

  const supportedLanguages = ["fi", "sv", "en"];
  return (
    <div className="App">
      <SurveyModal lang={langCode} />
      <Router>
        <Fragment>
          <ScrollToTop />
          <Switch>
            <Route
              path="/:lang/patentgazette/"
              render={(props) =>
                supportedLanguages.includes(props.match.params.lang) ? (
                  <PatentGazette activeLink={activeLink} setActiveLink={setActiveLink} />
                ) : (
                  <Redirect to={`/${props.match.params.lang ?? document.documentElement.lang}`} />
                )
              }
            />
            <Route
              path="/:lang/utilitymodelgazette/"
              render={(props) =>
                supportedLanguages.includes(props.match.params.lang) ? (
                  <UtilitymodelGazette activeLink={activeLink} setActiveLink={setActiveLink} />
                ) : (
                  <Redirect to={`/${props.match.params.lang ?? document.documentElement.lang}`} />
                )
              }
            />
            <Route
              path="/:lang/trademarkgazette/archive/"
              render={(props) => <Redirect to={`/${props.match.params.lang ?? document.documentElement.lang}`} />}
            />
            <Route
              path="/:lang/designgazette/archive/"
              render={(props) => <Redirect to={`/${props.match.params.lang ?? document.documentElement.lang}`} />}
            />
            <Route
              path="/:lang/trademarkgazette/"
              render={(props) =>
                supportedLanguages.includes(props.match.params.lang) ? (
                  <TrademarkGazette activeLink={activeLink} setActiveLink={setActiveLink} />
                ) : (
                  <Redirect to={`/${props.match.params.lang ?? document.documentElement.lang}`} />
                )
              }
            />
            <Route
              path="/:lang/designgazette/"
              render={(props) =>
                supportedLanguages.includes(props.match.params.lang) ? (
                  <DesignGazette activeLink={activeLink} setActiveLink={setActiveLink} />
                ) : (
                  <Redirect to={`/${props.match.params.lang ?? document.documentElement.lang}`} />
                )
              }
            />
            <Route
              path="/:lang/"
              render={(props) =>
                supportedLanguages.includes(props.match.params.lang) ? (
                  <MainPage activeLink={activeLink} setActiveLink={setActiveLink} />
                ) : (
                  <Redirect to={`/${document.documentElement.lang}/${props.match.params.lang}`} />
                )
              }
            />
            <Route path="/" render={() => <Redirect to={`/${document.documentElement.lang}`} />} />
          </Switch>
        </Fragment>
      </Router>
    </div>
  );
};

export default App;
